import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent, DialogData } from '../components/dialog/dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) { }

  showDialog(type: string, msg: string, pageType?: string) {
    let dialogData: DialogData = { title: type, content: msg, pageType: pageType ? pageType : null };
    this.dialog.open(DialogComponent, { data: dialogData, width: '25%' });
  }

  closeAll() {
    this.dialog.closeAll();
  }

}
